import { create } from "zustand"

interface CommonState {
  taskStatusList: any[]
  projectUpdate: boolean
  projectGroupList: any[]
  projectStatusList: any[]
  isRefetchFolders: boolean
  taskPrioritiesList: any[]
  organizationUserList: any[]
  headerBreadcrumbsList: any[]
  setTaskStatusListAction: (taskStatusList: any[]) => void
  setProjectUpdateAction: (projectUpdate: boolean) => void
  setIsRefetchFoldersAction: (isRefetchFolders: boolean) => void
  setProjectStatusListAction: (projectStatusList: any[]) => void
  setTaskPrioritiesListAction: (taskPrioritiesList: any[]) => void
  setProjectGroupListListAction: (projectGroupList: any[]) => void
  setOrganizationUserListAction: (organizationUserList: any[]) => void
  setHeaderBreadcrumbsListAction: (headerBreadcrumbsList: any[]) => void
}

export const useCommonStore = create<CommonState>((set) => ({
  taskStatusList: [],
  projectGroupList: [],
  projectUpdate: false,
  projectStatusList: [],
  taskPrioritiesList: [],
  isRefetchFolders: false,
  organizationUserList: [],
  headerBreadcrumbsList: localStorage.getItem("breadcrumbs")
    ? JSON.parse(localStorage.getItem("breadcrumbs") || "[]")
    : [],
  setTaskStatusListAction: (taskStatusList) => set({ taskStatusList }),
  setProjectUpdateAction: (projectUpdate: boolean) => set({ projectUpdate }),
  setProjectStatusListAction: (projectStatusList) => set({ projectStatusList }),
  setProjectGroupListListAction: (projectGroupList) => set({ projectGroupList }),
  setTaskPrioritiesListAction: (taskPrioritiesList) => set({ taskPrioritiesList }),
  setIsRefetchFoldersAction: (isRefetchFolders: boolean) => set({ isRefetchFolders }),
  setOrganizationUserListAction: (organizationUserList) => set({ organizationUserList }),
  setHeaderBreadcrumbsListAction: (headerBreadcrumbsList) => set({ headerBreadcrumbsList }),
}))
